import React, { useRef } from 'react';
import { experiencesData, myBG } from '../helper/constants';
import EmploymentDetails from '../helper/EmploymentDetails';

// const employmentContainerRef = useRef(null); // cant declare here

const Experiences = () => {
  const employmentContainerRef = useRef(null);

  return (
    <div id='experience' style={styles.heading}>
      <h2>Experience</h2>

      <div style={styles.experiencesContainer}>
        {/* verticalLine */}
        <div id='vertical-line' style={styles.verticalLine}></div>

        <div style={styles.employmentContainer}>
          {experiencesData.map((experience, index) => (
            <div
              key={index}
              style={index % 2 === 0 ? styles.leftEntry : styles.rightEntry}
            >
              <EmploymentDetails
                {...experience}
                employmentContainerRef={employmentContainerRef}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  heading: {
    // marginTop: '10px',
    marginLeft: '5px',
    marginBottom: '10px',
    marginRight: '5px',
    padding: '20px', // Add some padding to create space around the content
    // background: 'rgba(255, 255, 255, 0.2)', // Use an rgba color for the background with reduced opacity
    background: myBG,
    backdropFilter: 'blur(10px)', // Add a blur effect to create the glass panel effect
    borderRadius: '10px', // Add rounded corners for a better look
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', // Add a subtle shadow for depth
  },
  experiencesContainer: {
    position: 'relative',
    display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    // margin: '40px 0',
  },
  verticalLine: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    // left: '50%',
    left: '5%',
    // marginleft: '5px',
    width: 2,
    background: 'black',
  },
  employmentContainer: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    marginLeft: '10%',
    // marginLeft: '10px',
    // border: '1px dotted blue',
  },
  leftEntry: {
    marginBottom: '40px',
    // marginLeft: '100px',
    // width: '40%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    // marginRight: '100px',
    position: 'relative',
    // border: '1px solid yellow',
  },
  rightEntry: {
    marginBottom: '40px',
    // right: '10px',
    // marginRight: '100px',
    // paddingRight: '0px',
    // width: '40%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    // marginLeft: '100px',
    position: 'relative',
    // border: '1px solid green',
  },
};

export default Experiences;
